"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('folder-open', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", null, _react.default.createElement("g", null, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 21H40H9L4 41",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M19 7H6C4.89543 7 4 7.89543 4 9V41L9 21H40V15C40 13.8954 39.1046 13 38 13H24L19 7Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M4 41H40L44 21H40H9L4 41Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M19 7L20.5364 5.71963C20.1565 5.26365 19.5936 5 19 5V7ZM24 13L22.4636 14.2804C22.8435 14.7364 23.4064 15 24 15V13ZM40 41V43C40.9534 43 41.7742 42.3271 41.9612 41.3922L40 41ZM4 41H2C2 42.1046 2.89543 43 4 43V41ZM44 21L45.9612 21.3922C46.0787 20.8047 45.9266 20.1954 45.5467 19.732C45.1668 19.2686 44.5992 19 44 19V21ZM9 21V19C8.08226 19 7.2823 19.6246 7.05971 20.5149L9 21ZM6 9H19V5H6V9ZM17.4636 8.28037L22.4636 14.2804L25.5364 11.7196L20.5364 5.71963L17.4636 8.28037ZM24 15H38V11H24V15ZM40 39H4V43H40V39ZM6 41V9H2V41H6ZM7.05971 20.5149L2.05971 40.5149L5.94029 41.4851L10.9403 21.4851L7.05971 20.5149ZM42.0388 20.6078L38.0388 40.6078L41.9612 41.3922L45.9612 21.3922L42.0388 20.6078ZM44 19H40V23H44V19ZM40 19H9V23H40V19ZM38 15V21H42V15H38ZM38 15V15H42C42 12.7909 40.2091 11 38 11V15ZM6 5C3.79086 5 2 6.79086 2 9H6L6 9V5Z",
    fill: props.outStrokeColor
  }))));
});

exports.default = _default;